/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * PlanMarket
 */
export enum PlanMarket {
  OFF_EXCHANGE = 'OFF_EXCHANGE',
  ON_EXCHANGE = 'ON_EXCHANGE',
  BOTH_MARKETS = 'BOTH_MARKETS',
}
